import { Wording } from '@/types';

export const YOGA_WORDING_NO: Wording = {
  components_header_media_content: 'Treningsøkter',
  components_header_media_1: '',
  components_header_text1: 'Oppskrifter',
  components_header_text2: 'Blogg',
  components_header_members: 'Medlemmer',
  hero_text: 'Hold kroppen din fleksibel og sterk',
  hero_button_text: 'Start din yogareise',
  components_ressources_section_title: 'RESSURSER',
  components_ressources_subheader_text: 'Alle ressursene du trenger for en harmonisk livsstil',
  components_ressources_span_text: 'Lås opp hemmelighetene bak velvære: Dykk ned i en samling yogastillinger, mindful meditasjoner og sunne oppskrifter for å skape balanse i alle aspekter av livet ditt.',
  components_ressources_card_1_title: 'Yogatips',
  components_ressources_card_1_text: 'Praktiske råd for å fordype øvelsen din og perfeksjonere positurene dine.',
  components_ressources_card_2_title: 'Kosthold',
  components_ressources_card_2_text: 'Smarte kostholdstips for et sunnere og sterkere deg.',
  components_ressources_link: 'Se videoer',
  components_notes_and_google_title_1: 'Yogatrening',
  components_notes_and_google_title_2: 'Vanlig rutine',
  components_notes_and_google_title_3: 'Kostholdsvedlikehold',
  components_review_google_text: 'Anmeldelse på Google',
  media_content_section_title: 'TRENING',
  media_content_section_subheader_text: 'Våre videoer',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Flere videoer',
  text2_section_title: 'BLOGG',
  text2_section_subheader_text: 'Artikler og nyheter',
  text2_section_button_more: 'Flere artikler',
  components_text1_section_title: 'OPPSKRIFTER',
  components_text1_subheader_text: 'Gi næring til kropp og sinn',
  components_text1_span_text: 'Sunne oppskrifter som støtter yogapraksisen din og forbedrer velværet ditt.',
  components_text1_card_1_title: 'Energigivende frokoster',
  components_text1_card_1_text: 'Våkn opp til livlige, energigivende måltider.',
  components_text1_card_3_title: 'Matpakker med kraft',
  components_text1_card_3_text: 'Oppdag deilige og praktiske lunsjoppskrifter designet for din aktive livsstil. Fra fargerike salater til proteinrike wraps, holder disse oppskriftene deg mett og fokusert.',
  components_text1_card_2_title: 'Middager for restitusjon',
  components_text1_card_2_text: 'Utforsk et utvalg av magert protein, fullkorn og livlige grønnsaker for en tilfredsstillende avslutning på dagen.',
  components_text1_link: 'Se alle oppskrifter',
  components_footer_text: 'Finn balanse, pust dypt: Din yoga, din reise.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registreringsnummer',
  components_footer_legal: 'Juridisk',
  components_footer_terms: 'Vilkår og betingelser',
  components_footer_privacy: 'Personvernerklæring',
  button_load_more: 'Last inn mer',
  page_media_1_content_hero_text: 'Yogatrening',
  page_text1_hero_text: 'Oppskrifter',
  page_text1_section_title: 'Ernæring',
  page_text1_subheader_text: 'Oppskrifter',
  page_text2_hero_text: 'Bloggen vår',
  page_text2_section_title: 'Blogg',
  page_text2_subheader_text: 'Artikler og nyheter',
  enter_email_title: 'Vennligst skriv inn e-postadressen din for å fortsette',
  enter_email_placeholder_email: 'E-post',
  enter_email_button_enter: 'Gå',
  components_login_success_text: 'Innlogging vellykket!',
  components_card_link_media_content: 'Se nå',
  components_card_link_text1_content: 'Se oppskrift',
  components_card_link_text2_content: 'Vis artikkel',
  france: 'Frankrike',
  cyprus: 'Kypros',
};